import { Snackbar } from '@mui/material';
import React, { useState } from 'react';
import { Outlet } from 'react-router';
import styled from 'styled-components';

import { useCheckNotifications } from '../../../../shared/hooks/notificationHook';

import { CookieBanner } from './Cookie';
import { LayoutFooter } from './LayoutFooter';
import { LayoutHeader, LayoutHeaderContextProvider } from './LayoutHeader';
import { Sidebar } from './SidebarLayout';
import { LayoutBackground } from './components';

const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  padding-bottom: 15px;
  flex: 1;
`;

const Main = styled.main`
  flex: 1;
  max-width: 100%;
  box-sizing: border-box;
  padding-top: 19px;
  padding-right: 21px;
  padding-left: 13px;
  overflow: auto;

  ${p =>
    p.theme.isMobile &&
    `
    padding-top: 45px;
    padding-right: 28px;
    padding-left: 28px;
    `}
`;

export const Layout = () => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  useCheckNotifications();

  return (
    <>
      <LayoutBackground>
        <LayoutHeaderContextProvider>
          <LayoutHeader />
        </LayoutHeaderContextProvider>
        <Wrapper>
          <Sidebar />
          <Main>
            <Outlet />
          </Main>
        </Wrapper>
        <Snackbar
          open={errorMessage !== undefined}
          autoHideDuration={3000}
          onClose={() => setErrorMessage(undefined)}
          message={errorMessage}
        />
        {!window.env.FOOTER_DISABLED && <LayoutFooter />}
        <CookieBanner />
      </LayoutBackground>
    </>
  );
};
